<template>
	<div class="sideways-content-fold" v-if="activePanel">
		<div class="portlet light bordered">
			<div class="portlet-title">
				<div class="caption">
					<template v-if="process === 'step_1'">
						Edit Skill Testing Questions
					</template>
					<template v-if="process === 'step_2'">
						Create New Skill Testing Question
					</template>
				</div>
			</div>
			<div class="portlet-body">
				<div class="alert alert-danger" v-if="errorMessage.length">
				    <button class="close" data-close="alert" @click="clearError()"></button>
                    <span>{{ errorMessage }}</span>
				</div>
				<transition name="fade" mode="out-in">
					<div v-if="process === 'step_1'" key="step_1">
						<button type="button" class="btn blue btn-lg" @click="throttledCreate()">Create a New Skill Testing Question</button>
						<div v-if="questions.length" class="margin-top-20 row search-content-4">
	      					<div class="search-table table-responsive">
	      						<table class="table table-striped table-condensed">
	      							<thead>
	      								<tr>
	      									<th>Q</th>
	      									<th>A</th>
	      									<th></th>
	      								</tr>
	      							</thead>
	      							<tbody>
	      								<tr v-for="question in questions">
		      								<td><h4>{{ question.question }}</h4></td>
		      								<td>{{ question.answer }}</td>
		      								<td>
		      									<dropdown>
													<button slot="button" type="button" class="btn btn-sm btn-outline dropdown-toggle btn-default" data-toggle="dropdown">
														<i class="fa fa-cogs"></i>
													</button>
													<ul slot="dropdown-menu" class="dropdown-menu">
														<li>
															<a @click="deleteQuestionConfirmation(question)">Delete Question</a>
														</li>
													</ul>
												</dropdown>
		      								</td>
		      							</tr>
	      							</tbody>
	      						</table>
	      					</div>
	      				</div>
	      				<div v-if="!questions.length" class="center margin-top-20 font-grey-cascade">
							<i>No questions created yet.</i>
						</div>
					</div>
					<div v-if="process === 'step_2'" key="step_2">
						<form role="form" @submit.prevent="createQuestion($event)" novalidate>
							<div class="form-group form-md-line-input form-md-floating-label margin-bottom-20">
	                            <input type="text" class="form-control input-sm" :class="{'edited': newQuestion.question.length}" id="new_question_question" v-model.trim="newQuestion.question">
	                            <label for="new_question_question">Question</label>
	                        </div>
	                        <div class="form-group form-md-line-input form-md-floating-label margin-bottom-20">
	                            <input type="text" class="form-control input-sm" :class="{'edited': newQuestion.answer.length}" id="new_question_answer" v-model.trim="newQuestion.answer">
	                            <label for="new_question_answer">Answer</label>
	                        </div>
	                        <div class="form-actions noborder invite-user-actions margin-top-20">
	                        	<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To UNOgames Dashboard</button>
	                        	<button type="button" class="btn btn-default" @click="reverseForm()">Back</button>
	                        	<button type="submit" class="btn blue" key="edit-skill-testing-question-submit">Submit <i class="fa fa-arrow-circle-right"></i></button>
	                        </div>
						</form>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>
<script>
import Dropdown from '../../modules/Dropdown'
import GlobalFunctions from '../../../global'
import { findIndex, throttle } from 'lodash'
import { mapGetters } from 'vuex'
import UNOgames from '../../../controllers/UNOgames'

/**
 * Edit Skill Testing Questions module is a page for editing the skill testing questions of the contest.
 * @class EditSkillTestingQuestions
 * @extends UNOgames
 * @since 0.0.9
 */

export default {
	name: 'edit-contest-prizes',
	data () {
		return {
			process: 'step_1',
			activePanel: false,
			errorMessage: '',
			campaignId: 0,
			newQuestion: {
				question: '',
				answer: ''
			},
			steps: [{key: 'step_1', name: 'View Skill Testing Questions'}, {key: 'step_2', name: 'Create Skill Testing Question'}],
			questions: []
		}
	},
	created () {
		if (this.$route.name === 'UNOgames - Edit Skill Testing Questions') {
			this.activePanel = true
			if (this.$route.params.campaign_id && this.$route.params.campaign_id !== 'undefined' && parseInt(this.$route.params.campaign_id) !== 0) {
				this.campaignId = this.$route.params.campaign_id
				this.getSkillTestingQuestions()
			} else {
				this.closePanel()
			}
		} else {
			this.activePanel = false
		}

		this.throttledCreate = throttle(() => {
			this.createSkillTestingQuestion()
		}, 500, { 'trailing': false })
	},
	computed: mapGetters([
		'activeLocationId'
	]),
	methods: {
		/**
		 * To clear the current error.
		 * @function
		 * @returns {undefined}
		 * @memberof EditSkillTestingQuestions
		 * @version 0.0.9
		 */
		clearError () {
			this.errorMessage = ''
		},
		/**
		 * To close the edit skill testing questions panel by redirecting to the dashboard.
		 * @function
		 * @returns {undefined}
		 * @memberof EditSkillTestingQuestions
		 * @version 0.0.9
		 */
		closePanel () {
			this.process = 'step_1'
			this.$router.push('/app/uno_games')
		},
		/**
		 * To clear the object 'newQuestion'.
		 * @function
		 * @returns {undefined}
		 * @memberof EditSkillTestingQuestions
		 * @version 0.0.9
		 */
		clearForm () {
			this.newQuestion = {
				question: '',
				answer: ''
			}
		},
		/**
		 * To pull in all existing skill testing questions for the current campaign.
		 * @function
		 * @returns {undefined}
		 * @memberof EditSkillTestingQuestions
		 * @version 0.0.9
		 */
		getSkillTestingQuestions () {
			let _this = this

			UNOgames.getSkillTestingQuestions(_this.activeLocationId, _this.campaignId).then(response => {
				_this.questions = response.payload.questions
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {
					case 'questions_not_found':
						_this.questions = []
						break
					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To move the form back to the previous step.
		 * @function
		 * @returns {undefined}
		 * @memberof EditSkillTestingQuestions
		 * @version 0.0.9
		 */
		reverseForm () {
			const index = findIndex(this.steps, ['key', this.process])
			if (index) {
				this.process = this.steps[index - 1].key
			}

			this.clearForm()

			return
		},
		/**
		 * To move to the create skill testing question form in order to create the question.
		 * @function
		 * @returns {undefined}
		 * @memberof EditSkillTestingQuestions
		 * @version 0.0.9
		 */
		createSkillTestingQuestion () {
			this.process = 'step_2'
		},
		/**
		 * To validate that all information on the current step is accurate before allowing the user to proceed.
		 * @function
		 * @param {string} step - The step to be tested.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof EditSkillTestingQuestions
		 * @version 0.0.9
		 */
		validateFormData (step) {
			let _this = this

			return new Promise((resolve, reject) => {
				switch (step) {
				case 'step_2':
					if (!_this.newQuestion.question.length) {
						reject('Question cannot be blank.')
					}
					if (!_this.newQuestion.answer.length) {
						reject('Answer cannot be blank.')
					}
					break

				default:
					resolve()
				}

				resolve()
			})
		},
		/**
		 * To pass the skill testing question details to the backend to create the new question.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @returns {undefined}
		 * @memberof EditSkillTestingQuestions
		 * @version 0.0.9
		 */
		createQuestion (event) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			return _this.validateFormData('step_2').then(response => {
				_this.clearError()

				UNOgames.createSkillTestingQuestion(_this.activeLocationId, _this.campaignId, _this.newQuestion).then(response => {
					_this.getSkillTestingQuestions()
					_this.process = 'step_1'
					_this.clearForm()
					disabledButton.complete()
				}).catch(_this.$root.errorWrapper(e => {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {}
					}
					disabledButton.cancel()
				}))
			}).catch(reason => {
				// If validation fails then display the error message
				_this.errorMessage = reason
				disabledButton.cancel()
			})
		},
		/**
		 * To delete a question from the current campaign.
		 * @function
		 * @param {object} question - The question that is being removed.
		 * @returns {undefined}
		 * @memberof EditSkillTestingQuestions
		 * @version 0.0.9
		 */
		deleteQuestionConfirmation (question) {
			let _this = this
			let buttonText = ''
			let messageText = ''
			let successMessage = ''

			buttonText = 'Delete Question'
			messageText = 'You won\'t be able to reverse this action.'
			successMessage = 'Your question has been deleted.'

			this.$swal({
				title: 'Are you sure?',
				html: messageText,
				type: 'warning',
				showCancelButton: true,
				confirmButtonText: buttonText,
				confirmButtonColor: '#d9534f',
				cancelButtonText: 'Cancel',
				allowOutsideClick: false,
				allowEscapeKey: false,
				allowEnterKey: false,
				showLoaderOnConfirm: true,
				preConfirm () {
					return new Promise((resolve, reject) => {
						UNOgames.deleteSkillTestingQuestion(_this.activeLocationId, _this.campaignId, question.id).then(() => {
							resolve('skill_testing_question_deleted')
						}).catch(_this.$root.errorWrapper(e => {
							if (e.responseJSON) {
								switch (e.responseJSON.declaration) {}
							}
						}))
					})
				}
			}).then(response => {
				_this.$swal({
					title: 'Success',
					html: successMessage,
					type: 'success',
					showCancelButton: true
				}).then(() => {
					_this.getSkillTestingQuestions()
				}, dismiss => {
					_this.getSkillTestingQuestions()
				})
			}, dismiss => {
				// Do nothing on dismiss
			})
		}
	},
	components: {
		Dropdown
	},
	watch: {
		/**
		 * To `watch` the $route in order to determine if this panel should be showing or not
		 * @function
		 * @returns {undefined}
		 * @memberof EditSkillTestingQuestions
		 * @version 0.0.9
		 */
		'$route' () {
			if (this.$route.name === 'UNOgames - Edit Skill Testing Questions') {
				this.activePanel = true
				this.clearError()
				this.clearForm()
				if (this.$route.params.campaign_id && this.$route.params.campaign_id !== 'undefined' && parseInt(this.$route.params.campaign_id) !== 0) {
					this.campaignId = this.$route.params.campaign_id
					this.getSkillTestingQuestions()
				} else {
					this.closePanel()
				}
			} else {
				this.activePanel = false
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// EditSkillTestingQuestions.vue?3677e8d8